<template>
  <content-form :id="id"></content-form>
</template>

<script>
  import contentForm from './form'
  export default {
    data() {
      return {
        id: 0
      }
    },
    created() {
      this.id = parseInt(this.$route.params.id)
    },
    components: {
      contentForm
    }
  }
</script>



// WEBPACK FOOTER //
// edit.vue?e869e30e